import React, { useState } from 'react';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import styles from './ImageField.module.scss';
import { Button } from '..';
import { compressImage } from '../../services/utilities';
import { store } from '../../../models';

export default React.memo(props => {
  const {
    id,
    ids,
    name,
    text,
    value,
    action,
    disabled = false,
    editText,
    onChange,
    removeText,
    uploadText,
    formMapping,
    compression = true,
    mode = 'compact',
    displayHelpText = false,
    accept = '.jpg, .jpeg, .png, .tif, .tiff, .gif',
  } = props;

  const [image, setImage] = useState('')

  const fileInput = React.createRef();

  const uploadImage = async event => {
    store.dispatch.loader.persistLoader({ persist: true });
    const { model = String(), trigger = {} } = action;
    
    const form = new FormData();
    form.append('front_image', event.target.file)
    await axios.post(`https://dlicenseocr.carecloud.com/api/getDLicenseData`, form, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then(res => {
      if(res.data.Data !== null) {
        const params = []
        const iv = res?.data?.iv;
        const AI_ENCRYPTION_KEY = '2595874569321569';
        const decryptforInsuranceCard = (data, ivBase64) => {
          const key = CryptoJS.enc.Utf8.parse(AI_ENCRYPTION_KEY); 
          const iv = CryptoJS.enc.Base64.parse(ivBase64); 
          //eslint-disable-next-line object-shorthand            
          const decrypted = CryptoJS.AES.decrypt(data, key, { iv: iv }); 
          return decrypted.toString(CryptoJS.enc.Utf8);
       }
        Object.keys(res.data.Data).map(key => [key, res.data.Data[key]]).forEach(item => {
          if(item[0].toLowerCase().includes('first')) params.push({ id: ids.find(mapping => mapping.toLowerCase().includes('first')), value: decryptforInsuranceCard(item[1],iv), fieldValid: true, paymentValid: true, isInitial: false, formMapping: formMapping.find(mapping => mapping.toLowerCase().includes('first'))})
          if(item[0].includes('Last')) params.push({ id: ids.find(mapping => mapping.includes('Last')), value: decryptforInsuranceCard(item[1],iv), fieldValid: true, paymentValid: true, isInitial: false, formMapping: formMapping.find(mapping => mapping.includes('last'))})
          if(item[0].includes('DOB')) params.push({ id: ids.find(mapping => mapping.includes('Birth')), value: decryptforInsuranceCard(item[1],iv).replace(/\./g, '/'), fieldValid: true, paymentValid: true, isInitial: false, formMapping: formMapping.find(mapping => mapping.includes('Birth'))})
          //eslint-disable-next-line no-nested-ternary
          if(item[0].includes('Gender')) params.push({ id: ids.find(mapping => mapping.includes('Gender')), value: decryptforInsuranceCard(item[1],iv) === 'M' ? 'Male' : decryptforInsuranceCard(item[1],iv) === 'F' ? 'Female' : 'Other', fieldValid: true, paymentValid: true, isInitial: false, formMapping: formMapping.find(mapping => mapping.includes('gender')), param: ids.find(mapping => mapping.includes('Gender'))})
        })

        params.forEach(param => {
          if(param.formMapping === 'gender') {
            store.dispatch[model][trigger.selectChange]({ param, id: param.id, value: param.value, formMapping: param.formMapping })
            store.dispatch.inputDropdown.updateValue(param.id, param.value);
          }
          else store.dispatch[model][trigger.change](param)
        })
        // store.dispatch.loader.hide();
        // store.dispatch.loader.activateLoader({ loading: false });
        store.dispatch.loader.persistLoader({ persist: false });
      }
    }).catch(err => {
      // store.dispatch.loader.activateLoader({ loading: false });
      store.dispatch.loader.persistLoader({ persist: false });
      console.log('Error ', err)
    })
  }

  const handleChange = value => {
    if(mode === 'compact')
      onChange({
        target: {
          name,
          value: value?.result,
          file: value?.file,
        },
      });
    else if(id === 'signupImageField') { 
      setImage(URL.createObjectURL(value?.file))
      onChange({
        target: {
          name,
          value: value?.result,
          file: value?.file,
        },
      });
    } else {
      setImage(URL.createObjectURL(value?.file))
      uploadImage({
        target: {
          name,
          file: value?.file,
          value: value?.result,
        },
      })
    }
  };

  const openUploader = () => fileInput.current.click();

  const handleFileChange = ev => {
    const file = (ev?.target?.files || [])[0];
    if (!file) return;

    if (compression) {
      return compressImage(file, (_, result) => handleChange({result, file}));
    }
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = ev => handleChange(ev.target.result);
  };
  const onInputClick = event => {
     // eslint-disable-next-line
    event.target.value = ''
  }
  const Card_Required =    store.getState().settings.required_Bit_2
  const Photo_Required_labled_front = Card_Required === "true" || Card_Required === true  ? ( <> {"Front"}<span style={{ color: 'red' }}>*</span> </>) : (text);
  return (
    <div className={mode === 'compact' ? styles.compactWrapper : styles.wrapper}>
      {/*eslint-disable-next-line no-nested-ternary*/}
      {mode === 'compact' ? (
        <div className={styles.compactfileInput}>
          <input type="file" accept={accept} ref={fileInput} onChange={handleFileChange} onClick={onInputClick} />
        </div>
        ) : image === '' ? (
          <>
            <label className={styles.fileInput}>
              <b>Drag & Drop your License here</b>
              Supported JPG & PNG
              <label id='uploadBtn' htmlFor='imageInput'>
                Upload
              </label>
            </label>
            <input type="file" accept={accept} id='imageInput' ref={fileInput} onChange={handleFileChange} onClick={onInputClick} style={{ display: 'none' }} />
          </>
        ) : (
          <div style={{ position: 'relative', width: '100%' }}>
            <label id='uploadBtnOnPreview' htmlFor='imageInput'>
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.50879 9.67979C8.36308 9.19136 9.72894 7.50565 9.72894 5.50008C9.72894 3.11414 7.80982 1.17773 5.40659 1.17773C2.52359 1.17773 1.08425 3.58096 1.08425 3.58096M1.08425 3.58096V1.60997M1.08425 3.58096H1.95304H3.00337" stroke="#D92D20" strokeWidth="0.972528" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M1.08425 5.5C1.08425 7.88593 3.02066 9.82234 5.40659 9.82234" stroke="#D92D20" strokeWidth="0.972528" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="1.95 1.95" />
              </svg> Reset
            </label>
            <input type="file" accept={accept} id='imageInput' ref={fileInput} onChange={handleFileChange} onClick={onInputClick} style={{ display: 'none' }} />
            <img src={image} className={styles.fileInput} alt='Preview' />
          </div>
        )
      }
      {
        displayHelpText ? <label id='helpingText'>Or Enter Your Data Manually</label> : <></>
      }
      {value && mode === 'compact' ? (
        <>
          <div className={styles.preview}>
            <div className={styles.previewText}>{text}</div>
            <div className={styles.previewImage}>
              <img src={value} alt={text} />
            </div>
          </div>
          {!disabled && (
          <>
            <div className={styles.action}>
              <Button secondary long low text={removeText} destructive onClick={_ => handleChange()} />
            </div>
            <div className={styles.action}>
              <Button secondary long low text={editText} main onClick={_ => openUploader()} />
            </div>
          </>
        )}
        </>
      ) : (
        <></>
      )}
      {!value && mode === 'compact' ? (
        <>
          {text ==="Front*"?<div className={styles.red}>{Photo_Required_labled_front}</div>:<div className={styles.text}>{text}</div>}
          <div className={styles.action} />
          {!disabled && (
            <div className={styles.action}>
              <Button secondary long low text={uploadText} main onClick={_ => openUploader()} />
            </div>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
});
